// extracted by mini-css-extract-plugin
module.exports = {"successPopup":"SuccessPopup_successPopup__1xHQL","wrap":"SuccessPopup_wrap__ANiK-","message":"SuccessPopup_message__3y418"};